var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-wrapper"},[_c('h2',[_vm._t("default")],2),_c('div',{staticClass:"underline"})])}
var staticRenderFns = []

export { render, staticRenderFns }